var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8 11.8804H3.41123C2.91443 11.8804 2.51123 11.4774 2.51123 10.9808C2.51123 10.4842 2.91443 10.0812 3.41123 10.0812H24.8C25.2968 10.0812 25.7 10.4842 25.7 10.9808C25.7 11.4774 25.2968 11.8804 24.8 11.8804Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4414 16.5648C18.9446 16.5648 18.5366 16.1618 18.5366 15.6652C18.5366 15.1686 18.9338 14.7656 19.4306 14.7656H19.4414C19.9382 14.7656 20.3414 15.1686 20.3414 15.6652C20.3414 16.1618 19.9382 16.5648 19.4414 16.5648Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1167 16.5648C13.6199 16.5648 13.2119 16.1618 13.2119 15.6652C13.2119 15.1686 13.6091 14.7656 14.1059 14.7656H14.1167C14.6135 14.7656 15.0167 15.1686 15.0167 15.6652C15.0167 16.1618 14.6135 16.5648 14.1167 16.5648Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78051 16.5648C8.28371 16.5648 7.87451 16.1618 7.87451 15.6652C7.87451 15.1686 8.27291 14.7656 8.76971 14.7656H8.78051C9.27731 14.7656 9.68051 15.1686 9.68051 15.6652C9.68051 16.1618 9.27731 16.5648 8.78051 16.5648Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4414 21.2269C18.9446 21.2269 18.5366 20.8238 18.5366 20.3272C18.5366 19.8306 18.9338 19.4276 19.4306 19.4276H19.4414C19.9382 19.4276 20.3414 19.8306 20.3414 20.3272C20.3414 20.8238 19.9382 21.2269 19.4414 21.2269Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1167 21.2269C13.6199 21.2269 13.2119 20.8238 13.2119 20.3272C13.2119 19.8306 13.6091 19.4276 14.1059 19.4276H14.1167C14.6135 19.4276 15.0167 19.8306 15.0167 20.3272C15.0167 20.8238 14.6135 21.2269 14.1167 21.2269Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78051 21.2269C8.28371 21.2269 7.87451 20.8238 7.87451 20.3272C7.87451 19.8306 8.27291 19.4276 8.76971 19.4276H8.78051C9.27731 19.4276 9.68051 19.8306 9.68051 20.3272C9.68051 20.8238 9.27731 21.2269 8.78051 21.2269Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9522 6.94636C18.4554 6.94636 18.0522 6.54333 18.0522 6.04673V2.09915C18.0522 1.60256 18.4554 1.19952 18.9522 1.19952C19.449 1.19952 19.8522 1.60256 19.8522 2.09915V6.04673C19.8522 6.54333 19.449 6.94636 18.9522 6.94636Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2584 6.94636C8.7616 6.94636 8.3584 6.54333 8.3584 6.04673V2.09915C8.3584 1.60256 8.7616 1.19952 9.2584 1.19952C9.7552 1.19952 10.1584 1.60256 10.1584 2.09915V6.04673C10.1584 6.54333 9.7552 6.94636 9.2584 6.94636Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_288_373",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 24,
    height: 24
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 3.09363H25.7999V26.9889H2.3999V3.09363Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_288_373)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02508 4.89314C5.91348 4.89314 4.19988 6.55206 4.19988 9.56402V20.4184C4.19988 23.4963 5.91348 25.19 9.02508 25.19H19.1747C22.2863 25.19 23.9999 23.5275 23.9999 20.5095V9.56402C24.0047 8.08263 23.6063 6.9311 22.8155 6.13943C22.0019 5.32376 20.7479 4.89314 19.1855 4.89314H9.02508ZM19.1747 26.989H9.0251C4.9391 26.989 2.3999 24.4713 2.3999 20.4181V9.56377C2.3999 5.57181 4.9391 3.09363 9.0251 3.09363H19.1855C21.2363 3.09363 22.9319 3.70778 24.0899 4.8677C25.2143 5.99644 25.8059 7.61937 25.7999 9.56617V20.5093C25.7999 24.506 23.2607 26.989 19.1747 26.989Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.f2dd4de8118fc391cee779e2789f321b.svg";
export { ForwardRef as ReactComponent };